import { useNavigate } from "react-router-dom";
import { formatSalesValue } from "../../utils/formatUtils";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";

const Detailtable = ({ id, outletName, itemList, loading, error }) => {
  let navigate = useNavigate();

  const showChart = (element) => {
    const { Name } = element;
    navigate("/show-all-chart", {
      state: {
        itemName: Name,
        outletName: outletName
      }
    });
  };

  return (
    <div className="max-w-7xl mx-auto">

      {/* Loading State */}
      {loading && (
        <div className="rounded-lg bg-blue-50 p-6 text-center shadow">
          <div className="text-blue-700 font-medium">
            Loading item details...
          </div>
        </div>
      )}

      {/* Error State */}
      {error && (
        <div className="rounded-lg bg-red-50 p-6 text-center shadow">
          <div className="text-red-700 font-medium">{error}</div>
        </div>
      )}

      {/* Table */}
      {!loading && !error && (
        <div className="bg-white shadow-lg rounded-xl border overflow-hidden">
          <div className="overflow-y-auto max-h-[75vh]">
            <table className="min-w-full text-sm text-center">

              {/* Header */}
              <thead className="bg-slate-100 sticky top-0 z-10">
                <tr className="text-gray-700">
                  <th className="px-4 py-3">S.N</th>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Brand</th>
                  <th className="px-4 py-3">Unit</th>
                  <th className="px-4 py-3">UOM</th>
                  <th className="px-4 py-3">Rate</th>
                  <th className="px-4 py-3">Total</th>
                  <th className="px-4 py-3">Taxable</th>
                  <th className="px-4 py-3">Last Purchase</th>
                  <th className="px-4 py-3 text-center">View Chart</th>
                </tr>
              </thead>

              {/* Body */}
              <tbody>
                {itemList.length > 0 ? (
                  itemList.map((element, index) => (
                    <tr
                      key={index}
                      className="border-t hover:bg-slate-50 transition"
                    >
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2 font-medium">
                        {element.Name}
                      </td>
                      <td className="px-4 py-2">
                        {element.BrandName || "-"}
                      </td>
                      <td className="px-4 py-2">
                        {element.UnitsOrdered}
                      </td>
                      <td className="px-4 py-2">{element.UOM}</td>
                      <td className="px-4 py-2">
                        {(() => {
                          const rate = Number(element.Rate);
                          const last = Number(element.last_purchase);

                          if (!last || isNaN(last)) {
                            return rate;
                          }

                          if (rate < last) {
                            return (
                              <span className="flex items-center justify-center gap-1 text-green-600 font-medium">
                                {rate}
                                <AiOutlineArrowDown />
                              </span>
                            );
                          }

                          if (rate > last) {
                            return (
                              <span className="flex items-center justify-center gap-1 text-red-600 font-medium">
                                {rate}
                                <AiOutlineArrowUp />
                              </span>
                            );
                          }

                          return <span className="text-black">{rate}</span>;
                        })()}
                      </td>
                      <td className="px-4 py-2 font-semibold">
                        {formatSalesValue(Number(element.UnitsOrdered) * Number(element.Rate))}
                      </td>
                      <td className="px-4 py-2">
                        {element.Taxable}
                      </td>
                      <td className="px-4 py-2">
                        {element.last_purchase || "-"}
                      </td>
                      <td className="px-4 py-2 text-center">
                        <button
                          onClick={() => showChart(element)}
                          className="px-3 py-1 text-xs bg-blue-100 text-blue-700 rounded-md hover:bg-blue-200 transition"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="11"
                      className="text-center py-8 text-gray-500"
                    >
                      No item details available.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Detailtable;
